import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Trophy } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function LegendOfTheDay() {
  const [legend, setLegend] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLegend = async () => {
      try {
        const response = await axios.get(`${API}/sports/legends/daily/legend-of-the-day`);
        setLegend(response.data.legend);
      } catch (error) {
        console.error("Legend fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLegend();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-green-500/10 to-green-600/5 border-green-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!legend) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-green-500/10 to-green-600/5 border-green-500/20 hover:border-green-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center flex-shrink-0">
          <Trophy className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Günün Spor Efsanesi</h3>
          <Badge className="bg-green-500/80 text-white text-xs mt-1">{legend.sport}</Badge>
        </div>
      </div>
      
      <h4 className="text-lg font-bold text-green-200 mb-1 truncate">{legend.name}</h4>
      {legend.nickname && (
        <p className="text-green-100/70 text-xs mb-2">"{legend.nickname}"</p>
      )}
      <p className="text-white/70 text-xs line-clamp-2 mb-2">{legend.legacy || legend.bio}</p>
      
      {legend.achievements && legend.achievements.length > 0 && (
        <p className="text-green-100/80 text-xs italic line-clamp-1">
          🏆 {legend.achievements[0]}
        </p>
      )}
    </Card>
  );
}
